import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/Constants";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: token,
    },
  };
};

export const searchQuestionsAPI = createAsyncThunk(
  "search/searchQuestions",
  async (searchQuery, { rejectWithValue, signal }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/questions/search?q=${encodeURIComponent(searchQuery)}`,
        {
          ...getAuthHeader(),
          signal,
          timeout: 10000,
        }
      );

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Search failed"
      );
    }
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState: {
    searchResults: [],
    loading: false,
    error: null,
    searchText: "",
    currentRequestId: null,
  },
  reducers: {
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchText = "";
      state.error = null;
    },

    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchQuestionsAPI.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })

      .addCase(searchQuestionsAPI.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return;
        }

        state.loading = false;
        state.searchResults = action.payload || [];
        state.currentRequestId = null;
      })

      .addCase(searchQuestionsAPI.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return;
        }

        state.loading = false;
        state.error = action.payload;
        state.currentRequestId = null;
      });
  },
});

export const { clearSearchResults, setSearchText } = searchSlice.actions;

export default searchSlice.reducer;